import { useNavigate } from 'react-router-dom';

function heat(pct, total) {
  if (!total) return { bg: 'hsl(var(--secondary))', fg: 'hsl(var(--muted-foreground))', label: '—' };
  let color;
  if (pct >= 25) color = '#ef4444';
  else if (pct >= 15) color = '#f97316';
  else if (pct >= 8) color = '#f59e0b';
  else if (pct > 0) color = '#84cc16';
  else color = '#10b981';
  const intensity = Math.min(0.25 + pct / 40, 0.95);
  return { bg: color, opacity: intensity, fg: '#0b0f17', label: `${pct}%` };
}

export default function HeatGrid({ towers = [] }) {
  const navigate = useNavigate();
  const maxCols = Math.max(1, ...towers.map((t) => (t.lifts || []).length));
  return (
    <div className="overflow-x-auto">
      <div className="space-y-2" style={{ minWidth: 120 + maxCols * 84 }}>
        {towers.map((t) => (
          <div key={t.id} className="flex items-center gap-2" data-testid={`heat-tower-${t.id}`}>
            <div className="w-28 shrink-0 truncate text-sm font-medium">{t.name}</div>
            <div className="flex gap-2">
              {(t.lifts || []).map((l) => {
                const h = heat(l.stats.damage_pct, l.stats.total);
                return (
                  <button key={l.id} data-testid={`heat-cell-${l.id}`} onClick={() => navigate(`/lifts/${l.id}`)}
                    title={`${l.name} · ${l.stats.total} sites · ${l.stats.damage_pct}% damage`}
                    className="tile-press flex h-16 w-20 flex-col items-center justify-center rounded-lg border border-border text-center"
                    style={{ background: h.opacity != null ? `${h.bg}` : h.bg, opacity: 1 }}>
                    <span className="flex h-full w-full flex-col items-center justify-center rounded-lg" style={{ background: h.opacity != null ? hexA(h.bg, h.opacity) : h.bg }}>
                      <span className="text-[10px] font-medium" style={{ color: h.opacity ? '#fff' : h.fg }}>{l.name}</span>
                      <span className="font-head text-base font-bold" style={{ color: h.opacity ? '#fff' : h.fg }}>{h.label}</span>
                    </span>
                  </button>
                );
              })}
              {!(t.lifts || []).length && <span className="text-xs text-muted-foreground">No lifts</span>}
            </div>
          </div>
        ))}
      </div>
      <div className="mt-3 flex items-center gap-3 text-[10px] text-muted-foreground">
        <span>Low damage</span>
        <div className="flex h-2 w-40 overflow-hidden rounded-full">
          {['#10b981', '#84cc16', '#f59e0b', '#f97316', '#ef4444'].map((c) => <span key={c} className="flex-1" style={{ background: c }} />)}
        </div>
        <span>High damage</span>
      </div>
    </div>
  );
}

function hexA(hex, a) {
  const n = parseInt(hex.slice(1), 16);
  return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${a})`;
}
